/* AgentProfileCardWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D%0A._39xV02wBC3%7Bwidth%3A360px%7D%0A._0KLXruoI2d%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D%0A._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");



import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
const styles = {
  wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
  wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
export const AgentProfileCardWrapper = ({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  if (expValEquals('platform_editor_agent_mentions', 'isEnabled', true) && fg('platform_editor_agent_mentions_drop_one_fixes') || fg('platform_editor_agent_card_fixes')) {
    return <Box xcss={styles.wrapper}>{children}</Box>;
  }
  return <Box xcss={styles.wrapperLegacy}>{children}</Box>;
};